/* eslint-disable camelcase */
export interface TypedPrices {
  type: string;
  formatted: string;
  amount: number | null;
}

export interface Rebate {
  Name: string;
  Value: number;
  IdentCode: string;
  offerDescription: string;
  offerEndDate: string;
  offerStartDate: string;
}

export const PricesPriorityOrder = [
  'regular',
  'OEMDiscount',
  'dealerMarkup',
  'dealerDocFees',
  'destinationAndHandlingFees',
  'dealerDiscount',
  'dealerPrice',
  'nonConditionalBonus',
  'retail',
];

// Canadian New Vehicles
export const CanadianPricesPriorityOrder = [
  'regular',
  'freightPDI',
  'acLevy',
  'tireLevy',
  'motoCouncil',
  'adminFee',
  'luxuryTax',
  'OEMDiscount',
  'dealerDiscount',
  'dealerMarkup',
  'dealerDocFees',
  'destinationAndHandlingFees',
  'dealerPrice',
  'retail',
  'nonConditionalBonus',
];

export const TAXES_AND_LEVIES_KEYS = [
  'freightPDI',
  'acLevy',
  'tireLevy',
  'motoCouncil',
  'adminFee',
  'luxuryTax',
];

export const UsedPricesPriorityOrder = [
  'regular',
  'retail',
  'dealerPrice',
  'dealerDiscount',
  'dealerMarkup',
  'OEMDiscount',
  'dealerDocFees',
  'destinationAndHandlingFees',
  'nonConditionalBonus',
  'final',
];

export interface VehicleDetails {
  id: string;
  modelID: string;
  audiCode: string;
  stockNumber: string;
  vehicleType: string;
  modelName: string;
  modelMake: string;
  modelPrice: string;
  modelYear: string;
  driveType: string;
  isAvailableNow: string;
  warrantyType: string | undefined;
  dealerId: string;
  dealerName: string;
  dataSource: string;
  typedPrices: TypedPrices[];
  rebate: Rebate[];
}

export interface VehicleBag {
  vehicle: VehicleDetails | undefined;
  market: string;
  loading: boolean;
}

export interface StaticVehicleData {
  // eslint-disable-next-line camelcase
  rapid_name: string;
}
